import {ApolloClient, ApolloLink} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import {onError} from '@apollo/client/link/error';
import {createUploadLink} from 'apollo-upload-client';

export function createApolloClient(): ApolloClient<object> {
  const errorLink = onError(({graphQLErrors}) => {
    if (graphQLErrors?.some((e) => e.message === 'Login required')) {
      window.location.href = '/signin';
    }
  });

  const uploadLink = createUploadLink({
    uri: '/graphql',
    credentials: 'include',
  });

  return new ApolloClient({
    cache: new InMemoryCache({}),
    link: ApolloLink.from([errorLink, uploadLink]),
  });
}
